export const site = "EDB"; //"EDB" | "CKOB"
